import { useEffect, useState } from "react"
import { EnkCheckbox } from "../components/inputs/checkbox"
import { EnkButton, EnkPrimaryButton } from "../components/common/buttons"
import { EnkFieldGroup } from "../components/inputs/field-group"
import { EnkFieldSet } from "../components/inputs/field-set"
import { EnkButtonBar } from "../components/common/buttons"
import EnkPageContainer from "../components/page-container"
import EnkContentLoadingAndError from "../components/error-box"
import { EnkIWPServerAuth as ApiAuth, TEnkIWPUserNotifications } from "../api/api-iwp-server"

export default function EnkNotificationsPage() {
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [saving, setSaving] = useState(false)
  const [notifications, setNotifications] = useState<TEnkIWPUserNotifications>({
    notifyNewsletter: false,
    notifyCalendarEvents: false,
    notifyDocuments: false,
  })

  useEffect(() => {
    ApiAuth.getNotifications()
      .then((fetched) => {
        setNotifications(fetched)
        setLoading(false)
      })
      .catch((err) => {
        console.error("Failed to fetch notification settings:", err)
        setError("Er is een fout opgetreden bij het ophalen van je notificatie-instellingen.")
        setLoading(false)
      })
  }, [])

  const handleSave = async () => {
    setSaving(true)
    setError(null)
    try {
      await ApiAuth.saveNotifications(notifications)
    } catch (err) {
      console.error("Failed to save notification settings:", err)
      setError("Er is een fout opgetreden bij het opslaan van je notificatie-instellingen.")
    } finally {
      setSaving(false)
    }
  }

  const update = (field: keyof TEnkIWPUserNotifications) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setNotifications((prev) => ({ ...prev, [field]: e.target.checked }))
  }

  return (
    <EnkPageContainer>
      <EnkContentLoadingAndError loading={loading} error={error}>
        <form onSubmit={(e) => { e.preventDefault(); void handleSave() }}>
          <EnkFieldGroup
            label="Notificaties"
            description="Hier kunt u instellen welke notificaties u wilt ontvangen voor belangrijke updates en meldingen."
          >
            <EnkFieldSet label="Via e-mail" className="col-span-full">
              <EnkCheckbox
                label="Nieuws"
                id="news"
                description="Ontvang periodieke nieuwsbrieven."
                checked={notifications.notifyNewsletter}
                onChange={update("notifyNewsletter")}
              />
              <EnkCheckbox
                label="Geplande werkzaamheden"
                id="comments"
                description="Wordt genotificeerd als er geplande werkzaamheden aan zitten te komen."
                checked={notifications.notifyCalendarEvents}
                onChange={update("notifyCalendarEvents")}
              />
              <EnkCheckbox
                label="Documenten"
                id="documents"
                description="Ontvang een bericht als er documenten voor je klaar worden gezet."
                checked={notifications.notifyDocuments}
                onChange={update("notifyDocuments")}
              />
            </EnkFieldSet>
          </EnkFieldGroup>

          <EnkButtonBar>
            <EnkButton text="Annuleren" />
            <EnkPrimaryButton text={saving ? "Opslaan..." : "Opslaan"} onClick={() => void handleSave()} />
          </EnkButtonBar>
        </form>
      </EnkContentLoadingAndError>
    </EnkPageContainer>
  )
}
